import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';

import type { BulkUpdateJob, BulkUpdateState } from './bulk.update.types';
import type { RootState } from 'store/root-state';

type BulkUpdateJobProps = {
  bulkUpdateJobId: string;
};

type BulkUpdateDrawerPropertyProps = {
  property: string;
};

export const selectBulkUpdateJob = (state: BulkUpdateState, { bulkUpdateJobId }: BulkUpdateJobProps): BulkUpdateJob =>
  get(state, `jobIdtoJobMap.${bulkUpdateJobId}`, {
    dataType: '',
    ids: [],
    model: {},
    bulkActions: [],
  });
const selectJobIdToJobMap = (state: BulkUpdateState): Record<string, BulkUpdateJob> =>
  get(state, 'jobIdtoJobMap', emptyObject as BulkUpdateState['jobIdtoJobMap']);
export const selectLastAddedJobId = (state: BulkUpdateState): string => get(state, 'lastAddedJobId', '');
const selectDrawerBulkUpdate = (state: BulkUpdateState): BulkUpdateJob | undefined => get(selectJobIdToJobMap(state), 'drawer-bulk-update');
// The property name is whatever the caller asks for, so the honest return type is `unknown`.
export const selectDrawerBulkUpdateProperty = (state: BulkUpdateState, props: BulkUpdateDrawerPropertyProps): unknown =>
  get(selectDrawerBulkUpdate(state), props.property);

export const selectBulkUpdateBulkUpdateJob = (state: RootState, props: BulkUpdateJobProps): BulkUpdateJob =>
  selectBulkUpdateJob(get(state, 'bulk.update'), props);
export const selectBulkUpdateLastAddedJobId = (state: RootState): string => selectLastAddedJobId(get(state, 'bulk.update'));
export const selectBulkUpdateDrawerBulkUpdateProperty = (state: RootState, props: BulkUpdateDrawerPropertyProps): unknown =>
  selectDrawerBulkUpdateProperty(get(state, 'bulk.update'), props);
